
interface ErrorResponse {
    code: number;
    message: string;
}

export interface encryptedTGLink {
    link: string;
}

export interface EncryptedTGLinkState {
    encryptedTGLinkData: encryptedTGLink;
    loadingencryptedTGLinkData: boolean;
    encryptedTGLinkDataError: ErrorResponse | null;
}

export enum EncryptedTGLinkActionTypes {
    FETCH_ENCRIPTION_TG_LINK_DATA = "FETCH_ENCRIPTION_DATA",
    FETCH_ENCRIPTION_TG_LINK_SUCCESS = "FETCH_ENCRIPTION_DATA_SUCCESS",
    FETCH_ENCRIPTION_TG_LINK_ERROR = "FETCH_ENCRIPTION_DATA_ERROR",
}

export type EncryptedTGLinkCreateAction =
    | { type: EncryptedTGLinkActionTypes.FETCH_ENCRIPTION_TG_LINK_DATA }
    | { type: EncryptedTGLinkActionTypes.FETCH_ENCRIPTION_TG_LINK_SUCCESS; payload: encryptedTGLink }
    | { type: EncryptedTGLinkActionTypes.FETCH_ENCRIPTION_TG_LINK_ERROR; payload: ErrorResponse };